window.addEventListener("DOMContentLoaded", () => {
  const forms = document.querySelectorAll(".form");

  const statuses = {
    success: "The form has been successfully submitted.",
    error: "Something went wrong.",
  };

  const displayStatus = (formStatus, status) => {
    formStatus.innerHTML = statuses[status];
    formStatus.classList.add("active");

    if ((status = "error")) {
      formStatus.classList.add("status--error");
    } else {
      formStatus.classList.add("status--success");
    }
  };

  const resetForm = (form, formStatus) => {
    setTimeout(() => {
      const fields = ["input", "textarea"];

      fields.forEach((field) => {
        form.querySelectorAll(field).forEach((item) => {
          item.value = "";
        });
      });

      formStatus.innerHTML = "";
      formStatus.classList.remove("active");
      formStatus.classList.remove("status--error");
      formStatus.classList.remove("status--success");
    }, 15000);
  };

  forms.forEach((form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault();

      const formStatus = form.querySelector(".form-status");
      form.querySelector('button[type="submit"]').classList.add("loading");

      const formData = new FormData(form);

      fetch("sendmail.php", {
        method: "POST",
        body: new URLSearchParams(formData),
      })
        .then((response) => {
          if (response && response.status === 200) {
            return response.json();
          }
        })
        .then((data) => {
          form
            .querySelector('button[type="submit"]')
            .classList.remove("loading");

          if (data && data.status) {
            displayStatus(formStatus, "success");
          } else {
            displayStatus(formStatus, "error");
          }

          resetForm(form, formStatus);
        })
        .catch((e) => {
          displayStatus(formStatus, "error");
          resetForm(form, formStatus);
        });
    });
  });
});
